import getScribeLengthMs from 'JS/playback/lib/Playback/helpers/getScribeLengthMs';
import { appServices } from 'JS/shared/helpers/app-services/AppServices';
import getAudioFileDuration from 'JS/shared/helpers/getAudioFileDuration';

export default async function getAudioFadeoutTimings(clip, scribe) {
  const { assetId, fadeOutDurationSeconds = 0 } = clip;

  if (!fadeOutDurationSeconds) return;

  const assetUrl = await appServices.getAssetUrl(assetId);
  const audioFile = await (await window.fetch(assetUrl)).blob();
  const clipDurationSeconds = await getAudioFileDuration(audioFile);
  const scribeLengthSeconds = getScribeLengthMs(scribe) / 1000;
  const halfClipDurationSeconds = clipDurationSeconds / 2;
  const halfScribeLengthSeconds = scribeLengthSeconds / 2;

  const adjustedFadeOutTime = Math.min(fadeOutDurationSeconds, halfClipDurationSeconds, halfScribeLengthSeconds);
  const shortestEndTime = Math.min(clipDurationSeconds, scribeLengthSeconds);
  const fadeStartTime = shortestEndTime - adjustedFadeOutTime;

  return { fadeOutDurationSeconds: adjustedFadeOutTime, fadeOutStartTimeSeconds: fadeStartTime };
}
